import gql from 'graphql-tag';

export default gql`
  mutation login(
    $loginName: String!
    $password: String!
    $doNotMerge: Boolean
    $captchaToken: String
    $googleReCaptchaToken: String
    $action: String
  ) {
    login(
      loginName: $loginName
      password: $password
      doNotMerge: $doNotMerge
      captchaToken: $captchaToken
      googleReCaptchaToken: $googleReCaptchaToken
      action: $action
    ) {
      loginStatus
    }
  }
`;
